export default __webpack_public_path__ + "static/media/watson-1.620a1309.png";